import cx from 'classnames';

import DocumentSearchIcon from '../assets/svgs/document-search.svg';
import styles from './noData.module.scss';

const NoData = () => {
  return (
    <div className={cx(styles.wrapper, styles.noList)}>
      <div className={styles.center}>
        <DocumentSearchIcon />
        <p>No data found</p>
      </div>
    </div>
  );
};

export default NoData;
